import tagsTypes from '../../constants/tagsTypes'
export * from './get'
export * from './create'
export * from './getindex'
export * from './update'

const set_tag_errors = (messages) => {
  return {
    type: tagsTypes.set_errors,
    payload: messages
  }
}

const reset_tag = () => {
  return {
    type: tagsTypes.reset
  }
}

export {
  set_tag_errors,
  reset_tag,
}



// WEBPACK FOOTER //
// ./src/js/actions/tags/index.js